export enum Resources {
    // Login
    LOGIN = 'login',

    // Admin
    ADMIN = 'admin',
    ADMIN_ORG_MANAGEMENT = 'admin_org_management',
    ADMIN_USER_MANAGEMENT = 'admin_user_management',
    ADMIN_RISK_PORTFOLIO = 'admin_risk_portfolio',
    ADMIN_ENGINE_API_TOKENS = 'admin_engine_api_tokens',
    ADMIN_GEOSPATIAL_CATALOGUE = 'admin_geospatial_catalogue',

    // Customers
    CUSTOMERS = 'customers',

    // Projects
    PROJECTS = 'projects',
    PROJECT_DEFINITION = 'project_definition',
    PROJECTS_LIST = 'projects_list',
    NEW_PROJECT_DEFINITION = 'new_project_definition',
    PROJECT_ADMIN = 'project_admin',
    SITE_FILES = 'site_files',
    SITE_SUMMARY = 'site_summary',

    // Map resources
    MAPS = 'maps',
    SPECIES_INSIGHTS_MAP = 'species_insights_map',
    HABITAT_INSIGHTS_MAP = 'habitat_insights_map',
    FREEMIUM_SPECIES_INSIGHTS = 'freemium_species_map',

    // Dashboard
    DASHBOARD = 'dashboard',

    // Other
    USER = 'user',
    HABITAT_INSIGHTS_PAGE = 'hlca',

    // Survey
    SURVEY_DESIGN = 'survey_design',
    SURVEY_ADMIN = 'survey_admin',
    NEW_SURVEY_DESIGN = 'new_survey_design',
    SURVEY_DESIGN_SUMMARY = 'survey_design_summary',
    HABITAT_INSIGHTS_UPLOAD = 'habitat_insights_upload',

    // Ecology Hub
    ECO_STATS = 'eco_stats',
    COMMUNITY_COMPARISON = 'community_comparison',
    SPECIES_TRENDS = 'species_trends',
    HABITAT_TRENDS = 'habitat_trends',
    SAMPLE_COMPARISON = 'sample_comparison',
    STATISTICAL_COMPARISON = 'statistical_comparison',
    TAXONOMIC_COMPARISON = 'taxonomic_comparison',

    // Tables
    TABLES = 'tables',
    SAMPLES_TABLE = 'samples_table',
    HABITAT_INSIGHTS_TABLE = 'habitat_insights_table',

    // Samples
    SAMPLES = 'samples',

    // Upgrade Subscription
    UPGRADE_SUBSCRIPTION = 'upgrade_subscription',

    // Portfolio
    PORTFOLIO = 'portfolio',
    PORTFOLIO_SUMMARY = 'portfolio_summary',
    PORTFOLIO_SITE_EXPLORER = 'portfolio_site_explorer',
    PORTFOLIO_SPECIES_RISK_INDICATORS = 'portfolio_species_risk_indicators',
    PORTFOLIO_RISK_INSIGHTS = 'portfolio_risk_insights',

    // Site Nature Risk
    SITE_NATURE_RISK = 'site_nature_risk',
}
